interface OpenWindowProps {
    name?: string;
    width?: number;
    height?: number;
    resizable?: boolean;
}

export const openWindow = (path: string, windowProps?: OpenWindowProps, baseUrl: string = process.env.ECONOMIC_PATH) => {
    const width = windowProps?.width || 750;
    const height = windowProps?.height || 500;
    const url = `${baseUrl}${path}`;
    const x = (window.screen.width - width) / 2;
    const y = (window.screen.height - height) / 2;
    const resizable = windowProps?.resizable ?? true;

    if (!windowProps?.name) {
        return window.open(url);
    }

    return window.open(
        url,
        windowProps?.name,
        `width=${width},height=${height},screenX=${x},screenY=${y},resizable=${
            resizable ? 'yes' : 'no'
        },toolbar=no,menubar=no,scrollbars=yes,status=no,location=no`
    );
};
